<template>
  <div class="social-connect-buttons">
    <ul class="social-buttons-list rounded text-center mb-0 py-3">
      <li
        class="social-button-item list-inline-item mr-1 position-relative twitter"
      >
        <a
          href="https://twitter.com/unstitched_xyz"
          class="social-button-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <font-awesome-icon
            :icon="['fab', 'twitter']"
            size="2x"
            class="social-icon position-absolute"
          />
        </a>
      </li>
      <li
        class="social-button-item list-inline-item mr-1 position-relative instagram"
      >
        <a
          href="https://www.instagram.com/unstitched.xyz/"
          class="social-button-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <font-awesome-icon
            :icon="['fab', 'instagram']"
            size="2x"
            class="social-icon position-absolute"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {}
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_social_buttons.scss";

.social-connect-buttons {
  .social-button-link {
    color: rgba(#0e0e52, 0.5);
    &:hover {
      color: #fff;
      text-shadow: 0 8px 12px rgba(black, 0.2);
      &:before {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogEntry/ConnectButtons.vue